module.exports = new __parcel__URL__("JiraSelectBoardIllustrationSpork.e3235199.svg").toString();